{
  "version": 1,
  "asset_id": "bac52bdb-0818-41e4-97fa-886a6bde1630",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/bac52bdb-0818-41e4-97fa-886a6bde1630/form-4180.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/bac52bdb-0818-41e4-97fa-886a6bde1630/form-4180.jpg",
  "original_filename": "form-4180.jpg",
  "size": 184262,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:39:25Z"
}
